export default __webpack_public_path__ + "static/media/flag.014db69c.svg";